import { environment } from 'src/environments/environment';

const LOGGER = 'logger';

export const registerLogger = function () {
	window[LOGGER] = { ...console };
	for (const method in console) {
		if (typeof console[method] === 'function') {
			if (!environment.enableLogger) {
				console[method] = function (...args) {};
			}
		}
	}
};

